import { render, staticRenderFns } from "./HeaderClienteNuevo.vue?vue&type=template&id=b650d6f0&scoped=true&lang=pug"
import script from "./HeaderClienteNuevo.vue?vue&type=script&lang=js"
export * from "./HeaderClienteNuevo.vue?vue&type=script&lang=js"
import style0 from "./HeaderClienteNuevo.vue?vue&type=style&index=0&id=b650d6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b650d6f0",
  null
  
)

export default component.exports